import styled from '@emotion/styled';

const TranscriptionHeader = styled('div')({
  paddingBottom: '1rem',
});

export default TranscriptionHeader;
